import { fetchAppealList } from "../../../api/postCall/fetchAppealList";
import { CaseAppealListRow } from "../../../data-model/caseAppealsTable";
import { logError } from "../../../utils/customLogger";
import { AppealListFilterPayload } from "../hooks/useFilterPayload";
import { CaseAppealsTableState } from "../hooks/useCaseAppealsTableData";

/**
 * Refetches appeal list data when Case Appeals table filters change.
 *
 * @param payload - Page, limit, and filters for `pharmacy/appeal/list`
 * @param setCaseAppealsState - Table loading/error/data state setter
 * @param setTableData - Raw API rows setter
 * @param setPaginationResetCount - Resets client pagination when filters change
 */
export const makePostCallForOncologySubmission = async (
  payload: AppealListFilterPayload,
  setCaseAppealsState: React.Dispatch<React.SetStateAction<CaseAppealsTableState>>,
  setTableData: React.Dispatch<React.SetStateAction<CaseAppealListRow[]>>,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
): Promise<void> => {
  try {
    setCaseAppealsState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    const response = await fetchAppealList(payload);

    if (response.success) {
      setCaseAppealsState({
        data: response,
        loading: false,
        error: null,
        showInlineLoader: false,
      });
      setTableData(response.rows);
      setPaginationResetCount((prev) => prev + 1);
    } else {
      setCaseAppealsState((prev) => ({
        ...prev,
        loading: false,
        error: response.message || "Failed to fetch appeal list",
      }));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    setCaseAppealsState((prev) => ({
      ...prev,
      loading: false,
      error: errorMessage,
    }));
    logError(error as Error, "Error in makePostCallForOncologySubmission");
  }
};
